<div class="highlighted-container container">
    <div class="row">
        <div class="highlighted">  
            <div class="region region-highlighted">
                <h1 class="page-header">
                    <span>{{ 'REQUEST_BANK_ACCOUNT_CHANGE_HEADING' | translate }}</span>
                </h1>
            </div>
        </div>
    </div>
</div>

<div class="main-container container">
    <div class="row" *ngIf="!isActiveLease">
        <section class="col-sm-2"></section>
        <section class="col-sm-8">
            <p class="page-subtitle">{{ 'COMMON_LBL_ERROR_MSG_NO_ACTIVE_LEASE' | translate }}</p>
            <p></p>
        </section>
        <section class="col-sm-2"></section>
    </div>
    <div class="row" *ngIf="isActiveLease">
        <section class="col-sm-2"></section>
        <section class="col-sm-8">
            <div class="region region-content">
                <form class="custom-from" #customForm="ngForm" (ngSubmit)="submitForm(customForm)" novalidate>
                    <p class="subtitle">{{ 'REQUEST_BANK_ACCOUNT_CHANGE_TITLE' | translate }}</p>
                    <div class="row">
                        <section class="col-sm-6 lb"><label class="star">*</label>{{ 'REQUEST_BANK_ACCOUNT_CHANGE_INPUT_INSTITUTION' | translate }}</section>
                        <section class="col-sm-6">
                            <input type="text" 
                                class="form-control" 
                                id="institutionNumber" name="institutionNumber" 
                                [(ngModel)]="request.institutionNumber"   
                                [ngClass]="{ 'is-invalid': formSubmitted && customForm.controls.institutionNumber.errors }"
                                placeholder="{{ 'COMMON_LBL_REQUIRED' | translate }}"                                              
                                (input)="institutionNumberValidator($event)" 
                                [pattern]="institutionPattern" required maxlength="3"/>
                            <div *ngIf="formSubmitted && customForm.controls.institutionNumber.errors" class="is-invalid-format">
                                <small> {{ 'REQUEST_BANK_ACCOUNT_CHANGE_ERR_INSTITUTION' | translate }} </small>
                            </div>
                        </section>
                        <section class="col-sm-6 lb"><label class="star">*</label>{{ 'REQUEST_BANK_ACCOUNT_CHANGE_INPUT_TRANSIT' | translate }}</section>
                        <section class="col-sm-6">
                            <input type="text" 
                                class="form-control" 
                                id="transitNumber" name="transitNumber" 
                                [(ngModel)]="request.transitNumber"   
                                [ngClass]="{ 'is-invalid': formSubmitted && customForm.controls.transitNumber.errors }"
                                placeholder="{{ 'COMMON_LBL_REQUIRED' | translate }}"                                              
                                (input)="transitNumberValidator($event)" 
                                [pattern]="transitPattern" required maxlength="5"/>
                            <div *ngIf="formSubmitted && customForm.controls.transitNumber.errors" class="is-invalid-format">
                                <small> {{ 'REQUEST_BANK_ACCOUNT_CHANGE_ERR_TRANSIT' | translate }} </small>
                            </div>                                
                        </section>
                        <section class="col-sm-6 lb"><label class="star">*</label>{{ 'REQUEST_BANK_ACCOUNT_CHANGE_INPUT_ACCOUNT' | translate }}</section>
                        <section class="col-sm-6">
                            <input type="text" 
                                class="form-control" 
                                id="accountNumber" name="accountNumber" 
                                [(ngModel)]="request.accountNumber"   
                                [ngClass]="{ 'is-invalid': formSubmitted && customForm.controls.accountNumber.errors }"
                                placeholder="{{ 'COMMON_LBL_REQUIRED' | translate }}"                                              
                                (input)="accountNumberValidator($event)" 
                                [pattern]="accountPattern" required maxlength="12"/>
                            <div *ngIf="formSubmitted && customForm.controls.accountNumber.errors" class="is-invalid-format">
                                <small> {{ 'REQUEST_BANK_ACCOUNT_CHANGE_ERR_ACCOUNT' | translate }} </small>
                            </div>                                                                 
                        </section>
                        <section class="col-sm-6 lb" *ngIf="voidChequeIsRequired"><label class="star">*</label>{{ 'REQUEST_BANK_ACCOUNT_CHANGE_INPUT_VOID_CHEQUE' | translate }}</section>
                        <section class="col-sm-6" style="text-align: right;" *ngIf="voidChequeIsRequired">
                            <input type="file"
                                id="voidChequeInput" name="voidChequeInput" 
                                style="display: none"
                                accept="application/pdf,image/bmp,image/jpg,image/jpeg,image/png,image/gif" 
                                (change)="handleFileInput($event.target.files)"/>
                            <button type="button" id="voidChequeBtn" class="btn btn-secondary btn-expand">{{ 'COMMON_BTN_SELECT_FILE' | translate }}</button>
                            <div *ngIf="!voidChequeFile" [ngClass]="{ 'is-invalid-file': formSubmitted }"><small> {{ 'COMMON_LBL_NO_FILE' | translate }} </small></div>
                            <div *ngIf="voidChequeFile"><small>{{ voidChequeFile?.name }}</small></div>
                            <div *ngIf="voidChequeFile && invalidVoidCheque" [ngClass]="{ 'is-invalid-file': invalidVoidCheque }"><small> {{ 'COMMON_LBL_ERROR_FILE' | translate }} </small></div>
                        </section>
                    </div>                   
                    <div *ngIf="formSubmitted && (customForm.invalid || invalidVoidCheque)" class="row" style="margin: auto;">
                        <div class="col-sm-12 error-note">
                            <label translate="COMMON_LBL_FORM_ERR_NOTE"></label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6"></div>
                        <div class="col-md-6">
                            <button type="submit" class="btn btn-secondary action-row">{{ 'COMMON_BTN_SUBMIT' | translate }}</button>
                        </div>
                    </div>
                </form>
                <div *ngIf="effectiveDateIsValid">{{ 'REQUEST_BANK_ACCOUNT_CHANGE_EFFECTIVE_DATE' | translate }}{{ bankAccountChangeViewModel.effectiveDate | date:'yyyy/MM/dd' }}</div>
                <div *ngIf="!effectiveDateIsValid">{{ 'REQUEST_BANK_ACCOUNT_CHANGE_EFFECTIVE_DATE' | translate }}</div>
                <div *ngIf="effectiveDateIsValid && showNewEffectiveDateNote" style="margin-top: 10px;">{{ 'REQUEST_BANK_ACCOUNT_CHANGE_NOTE' | translate }}</div>
            </div>
        </section>
        <section class="col-sm-2"></section>
    </div>
</div>